import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import {
  EnvironmentConfig,
  ENVIRONMENT_CONFIG,
} from '@cigna/chcp/shared/environment-util';
import { Router, NavigationEnd } from '@angular/router';
import { filter, take, takeUntil, startWith, map, skip } from 'rxjs/operators';
import { Subject } from 'rxjs';
import * as uuid from 'uuid';

@Component({
  selector: 'cigna-trust',
  template: '',
})
export class TrustComponent implements OnInit, OnDestroy {
  loadCCjs$ = new Subject();
  onDestroy$ = new Subject<void>();

  routerEvents$ = this.router.events.pipe(
    filter((e) => e instanceof NavigationEnd),
    map((event) => ({
      pageUrl: (event as NavigationEnd).urlAfterRedirects,
    })),
    startWith({ pageUrl: this.router.url }),
  );

  constructor(
    private cookieService: CookieService,
    @Inject(ENVIRONMENT_CONFIG) private envConfig: EnvironmentConfig,
    private router: Router,
  ) {}

  SITE_IDENTIFIER = this.envConfig.trustId;

  ngOnInit() {
    this.loadCCjs$.pipe(take(1)).subscribe(() => {
      this.loadCCJs();
    });

    this.routerEvents$.pipe(take(1)).subscribe(({ pageUrl }) => {
      const pageContext = pageUrl.includes('/login')
        ? 'login'
        : pageUrl.includes('/dashboard')
        ? 'main_account'
        : 'other';

      this.createCallback();
      this.loadTopJs(pageContext);

      if (pageContext === 'login') {
        this.loadCCjs$.next();
      }
    });

    this.routerEvents$
      .pipe(skip(1), takeUntil(this.onDestroy$))
      .subscribe(({ pageUrl }) => {
        if (
          pageUrl.includes('status=logout') ||
          pageUrl.includes('status=timeout')
        ) {
          this.createCallback();
          this.loadCCjs$.next();
        } else if (pageUrl.includes('/login')) {
          this.contextCallback('login');
          this.loadCCjs$.next();
        } else if (pageUrl.includes('/dashboard')) {
          this.contextCallback('main_account');
        } else {
          this.contextCallback('other');
        }
      });
  }

  createCallback() {
    const userCuid = this.cookieService.get('user_cuid');
    const userDn = this.cookieService.get('user_dn');
    let trusteerUuid = this.cookieService.get('tr.uuid');

    const isUnauthenticated =
      typeof userCuid === 'undefined' || userCuid === 'unauthenticated';

    if (isUnauthenticated) {
      trusteerUuid = uuid.v4();
      this.cookieService.set('tr.uuid', trusteerUuid, { secure: true });
    }

    (window as any).cFhcp = function () {
      return isUnauthenticated
        ? {
            c: trusteerUuid,
          }
        : {
            p: { p: userDn },
            u: { p: [userCuid] },
            c: trusteerUuid,
          };
    };
  }

  loadTopJs(pageContext: string) {
    const tag = document.createElement('script');
    tag.src = `//open-18.cigna.com/${
      this.SITE_IDENTIFIER
    }/topHcp.js?dt=${pageContext}&r=${Math.random()}`;
    tag.defer = true;
    const s = document.getElementsByTagName('script')[0];

    if (s && s.parentNode) {
      s.parentNode.insertBefore(tag, s);
    }
  }

  loadCCJs() {
    const tag = document.createElement('script');
    tag.src = `//closed-w.cigna.com/${
      this.SITE_IDENTIFIER
    }/Hhtk.js?r=${Math.random()}`;
    tag.defer = true;
    const s = document.getElementsByTagName('script')[0];

    if (s && s.parentNode) {
      s.parentNode.insertBefore(tag, s);
    }
  }

  contextCallback(context: string) {
    if ((window as any)['Hcpcn']) {
      (window as any)['Hcpcn'](context);
    }
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
